import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from '@clerk/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { initI18n } from '@yorukiri/i18n';
import { ApiAuthBridge } from './components/ApiAuthBridge';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LibraryRoute } from './routes/library';
import { PageRoute } from './routes/page';
import { ReviewRoute } from './routes/review';
import { SettingsRoute } from './routes/settings';
import { StatsRoute } from './routes/stats';
import { SignInRoute } from './routes/signin';
import { SignUpRoute } from './routes/signup';
import { InviteRoute } from './routes/invite';
import './styles/global.css';

initI18n();

const qc = new QueryClient();

const router = createBrowserRouter([
  { path: '/sign-in/*', element: <SignInRoute /> },
  { path: '/sign-up/*', element: <SignUpRoute /> },
  { path: '/invite/:token', element: <InviteRoute /> },
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      { index: true, element: <LibraryRoute /> },
      { path: 'pages', element: <PageRoute /> },
      { path: 'pages/:id', element: <PageRoute /> },
      { path: 'review/:pageId', element: <ReviewRoute /> },
      { path: 'settings', element: <SettingsRoute /> },
      { path: 'stats', element: <StatsRoute /> },
    ],
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ClerkProvider afterSignOutUrl="/sign-in">
      <ApiAuthBridge />
      <QueryClientProvider client={qc}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ClerkProvider>
  </StrictMode>,
);
